import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

import { ToastProvider } from "./components/feedback/ToastProvider";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;

const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

const root = ReactDOM.createRoot(document.getElementById("root"));

const onRedirectCallback = (appState) => {
  const target = appState?.returnTo || "/post-login";

  window.location.replace(target);
};

root.render(
  <BrowserRouter>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience,
      }}
      cacheLocation="localstorage"
      useRefreshTokens={false}
      onRedirectCallback={onRedirectCallback}
    >
      <ToastProvider>
        <App />
      </ToastProvider>
    </Auth0Provider>
  </BrowserRouter>,
);

reportWebVitals();
